var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoEhMark = function SvgLogoEhMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 88,
    "aria-label": "eskuvohelyszin.hu"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5BD24",
    d: "M50 96S12 60 12 36c0-14 10-24 23-24 8 0 13 5 15 11 2-6 7-11 15-11 13 0 23 10 23 24 0 24-38 60-38 60"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 40,
    r: 10,
    fill: "#FFF"
  }))));
};
export default SvgLogoEhMark;